import React, {useEffect, useState} from 'react'
import {ICandidateFull} from '../../types/candidate/ICandidateFull'
import {Link, useParams} from 'react-router-dom'
import candidateService, {candidateHooks} from '../../api/candidate.api'
import CreateResumeModal from '../../components/modals/CreateResumeModal'
import {Button, Form, ListGroup} from 'react-bootstrap'
import {API_URL} from '../../api'
import RemoveResume from './components/RemoveResume'
import {useTranslation} from 'react-i18next';
import PdfModal from "../../components/modals/pdf-modal";
import {toast} from "react-toastify";
import ReactInputMask from "react-input-mask";
import InfoCardCandidate from "./components/info-card-candidate";

type Props = {}
export type CandidateUpdateFormValue = {
  firstName: string
  lastName: string
  email: string
  phone: string
  category: {
    id: number | null
    name: string
  }
}

const Info = (props: Props) => {
  const {t} = useTranslation();
  const {id} = useParams()
  const [candidate, setCandidate] = useState<ICandidateFull | null>(null)
  const [vacancies, setVacancies] = useState<{ id: number, position: string }[]>([])
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [formValues, setFormValues] = useState<CandidateUpdateFormValue>(
    {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      category: {
        id: null,
        name: ''
      }
    }
  )

  const {data: categories} = candidateHooks.useCandidateCategories()
  const getListCategories = () => {
    if (!categories || !categories[0]) return []
    return categories[0]
  }

  const listCategories = getListCategories()


  const update = () => {
    candidateService.findById(Number(id)).then((response) => {
      const {data} = response

      setCandidate(data)

      setFormValues(
        {
          firstName: data?.firstName,
          lastName: data?.lastName,
          email: data?.email,
          phone: data?.phone,
          category: {
            id: data?.categoryId?.id ?? null,
            name: data?.categoryId?.name || ''
          }
        }
      )
    }).catch((e) => {
      console.log(e)
    })

    candidateService.getVacancies(Number(id)).then((response) => {
      setVacancies(response.data)
    }).catch((e) => {
      console.log(e)
    })
  }

  const handleUpdate = async () => {
    if (!id) {
      toast.error("ID-кандидата не найден!");
      return;
    }

    try {
      await candidateService.updateCandidate(id, formValues);
      toast.success("Данные кандидата успешно обновлены!");
      await update()
      setIsEditing(false);
    } catch (e) {
      toast.error("Ошибка при обновлении данных кандидата.");
    }
  }
  const handleEditClick = async () => {
    setIsEditing(!isEditing)
  };

  useEffect(() => {
    update()
  }, [id])


  return (
    <>
      <h5
        className='text-muted mb-4'>{t('CandidateDetailsTitle')}</h5> {/* Переводим заголовок "Подробнее о кандидате" */}
      <div className="white-form-block mb-3">
        {
          candidate && <div className='application-details-container'>
                <div className={'flex justify-between gap-4 mb-4 items-center'}>
                    <h4 className={'text-lg'}>{candidate.firstName} {candidate.lastName}</h4>
                    <div className={'gap-4 flex'}>
                      {isEditing &&
                          <Button
                              variant="outline-primary"
                              size="sm"
                              className="d-flex items-center p-1 px-2"
                              onClick={handleUpdate}
                          >
                              Сохранить
                          </Button>
                      }

                        <Button
                            variant="outline-primary"
                            size="sm"
                            className="d-flex items-center p-1 px-2"
                            onClick={handleEditClick}
                        >
                            <i className="bi bi-pencil-square"></i>
                        </Button>
                    </div>
                </div>


            {
              isEditing &&
                <div className="application-details-item">
                    <div className="title">
                      {'Имя'}
                    </div>
                    <input
                        className="form-control"
                        placeholder={candidate.firstName}
                        value={formValues.firstName}
                        required={true}
                        onChange={(e) => {
                          setFormValues((prev) => ({
                            ...prev,
                            firstName: e.target.value
                          }));
                        }}
                    />
                </div>
            }

            {
              isEditing &&
                <div className="application-details-item">
                    <div className="title">
                      {'Фамилия'}
                    </div>
                    <input
                        className="form-control"
                        placeholder={candidate.lastName}
                        value={formValues.lastName}
                        required={true}
                        onChange={(e) => {
                          setFormValues((prev) => ({
                            ...prev,
                            lastName: e.target.value
                          }));
                        }}
                    />
                </div>
            }

                <div className="application-details-item">
                    <div className="title">
                      {t('CandidateEmailTitle')}
                    </div>

                  {isEditing ? (
                    <input
                      className="form-control"
                      placeholder={candidate.email}
                      value={formValues.email}
                      type='email'
                      onChange={(e) => {
                        setFormValues((prev) => ({
                          ...prev,
                          email: e.target.value
                        }));
                      }}
                    />
                  ) : (
                    candidate.email !== "" ? (
                      <div className='value'>{candidate.email}</div>
                    ) : null
                  )}
                </div>

                <div className="application-details-item">
                    <div className="title">
                      {t('CandidatePhoneTitle')}
                    </div>

                  {isEditing ? (
                    <Form.Control
                      className="form-control"
                      placeholder={candidate.phone}
                      value={formValues.phone}
                      as={ReactInputMask} mask="+7 (999) 999-99-99"
                      onChange={(e) => {
                        setFormValues((prev) => ({
                          ...prev,
                          phone: e.target.value
                        }));
                      }}
                    />
                  ) : (
                    candidate.phone !== "" ? (
                      <div className='value'>
                        {candidate.phone}
                      </div>
                    ) : null
                  )}
                </div>

                <div className="application-details-item">
                    <div className="title">
                        <label>Категория</label>
                    </div>

                  {isEditing ? (
                    <Form.Control
                      as="select"
                      value={formValues.category.id ?? ""}
                      onChange={(e) => {
                        setFormValues((prev) => ({
                          ...prev,
                          category: {
                            ...prev.category,
                            id: e.target.value ? Number(e.target.value) : null
                          }
                        }));
                      }}
                    >
                      <option value="">Выберите категорию</option>
                      {listCategories?.map((category: any) => (
                        <option key={category.id} value={category.id}>
                          {category.name} ({category.code})
                        </option>
                      ))}
                    </Form.Control>
                  ) : formValues.category.name ? (
                    <div className="value">{formValues.category.name}</div>
                  ) : null}
                </div>

                <div className="application-details-item">
                    <div className="title">
                      {t('CandidateResumeTitle')}
                    </div>
                    <div className='value'>

                        <ul className='list-group mb-3'>
                          {
                            candidate.resumes && candidate.resumes.length > 0 && candidate.resumes.map((resume) => {
                              return (
                                <li className='list-group-item'>

                                  <div className='d-flex justify-content-between'>
                                    <div className='me-5'>
                                      {resume.name}
                                    </div>
                                    <div className="d-flex" style={{gap: 20}}>
                                      <PdfModal fileId={resume.file}/>
                                      <a key={resume.id} href={`${API_URL}${resume.file}`} download={true}
                                         target='_blank'
                                         rel="noreferrer">
                                        <i className="fa-solid fa-file-arrow-down text-success"
                                           style={{fontSize: '22px'}}></i>
                                      </a>
                                      <RemoveResume id={resume.id} update={update}/>
                                    </div>
                                  </div>

                                </li>
                              )
                            })
                          }
                        </ul>

                        <CreateResumeModal update={update} id={Number(id)}/>
                    </div>
                </div>
            </div>
        }
      </div>

    <InfoCardCandidate candidateId={Number(id)} isNeedDownload={true}/>
    </>
  )
}

export default Info
